export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9573.9f75eef7.jpg";